import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationFacade } from '../state';

@Injectable()
export class AuthenticatedGuard {
  constructor(private authenticationFacade: AuthenticationFacade) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.validateAccess(state.url);
  }

  canActivateChild(): boolean {
    return this.validateAccess('/');
  }

  canLoad(): boolean {
    return this.validateAccess('/');
  }

  private validateAccess(returnUrl: string) {
    if (this.authenticationFacade.hasValidAccessToken()) {
      this.authenticationFacade.accessTokenReceived();
      return true;
    }

    this.authenticationFacade.initLoginFlow(returnUrl ?? '/');
    return false;
  }
}
